import { type QueryClient } from '@tanstack/react-query';
import { type LoaderFunctionArgs, type RouteObject } from 'react-router-dom';

import { getTranslationLanguagesQuery } from '@/api/translation/getTranslationLanguages';
import { requirePermissions } from '@/app/requirePermissions';
import { ensureAppQueryData } from '@/hooks/useAppQuery';
import { PagePermissions } from '@/models/pagePermissions';

export const translationsRoute = (queryClient: QueryClient): RouteObject => ({
  path: 'translations',
  // On the parent, so the child keeps its own data loader untouched.
  loader: requirePermissions({ oneOf: PagePermissions.translations }),
  children: [
    {
      path: '',
      loader: async ({ params }: LoaderFunctionArgs) => {
        const { studioCode = '', gameCode, sandboxCode } = params;
        if (!gameCode || !sandboxCode) {
          throw new Error('Game code and sandbox code are required');
        }
        return {
          locales: await ensureAppQueryData(
            queryClient,
            { studioCode, gameCode, sandboxCode },
            getTranslationLanguagesQuery(),
          ),
        };
      },
      lazy: async () => await import('./translations'),
    },
  ],
});
